import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col, Button, Form, Card, ProgressBar } from 'react-bootstrap';
import Listing from 'components/Listing';
import MasterPage from 'components/MasterPage';
import { api } from 'services';
import Can from 'components/Can';
import { DashboardOutlined } from '@material-ui/icons';
import Dialog from 'react-bootstrap-dialog';
import { ASYNC_DELETE_EVENT, ASYNC_RESTORE_EVENT, ASYNC_FINISH_EVENT } from 'store';
import { connect } from 'react-redux';

const EventsList = ({ deleteEvent, restoreEvent, finishEvent, trash, finished, type }) => {
  const defaultFilters = { status_id: '', per_page: 10, page: 1 };

  const [data, setData] = useState({ data: [] });
  const [filters, setFilters] = useState(defaultFilters);
  let dialog;

  useEffect(() => {
    getEvents()
  }, [filters]);

  const getEvents = () => {
    api.get(!type ? 'events' : `events/${type}`, { params: filters })
    .then(({ data }) => {
      var _data = data.data
      _data = _data.map(item => {
        return {
          ...item,
          can_finish: item.actions_count[0] == item.actions_count[1] && !item.actions_count.includes(0),
          actions_count_string: `${item.actions_count[0]}/${item.actions_count[1]}`
        }
      })
      data.data = _data
      setData(data)
    });
  }

  const { t } = useTranslation();

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const effectDeleteEvent = (id) => {
    showDialog(id, t('title:event delete'), deleteEvent)
    // Dialog.setOptions({
    //   defaultOkLabel: t('label:yes'),
    //   defaultCancelLabel: t('label:no'),
    //   primaryClassName: 'btn-success',
    //   defaultButtonClassName: 'btn-danger',
    // });

    // dialog.show({
    //   title: t('title:event delete'),
    //   body: t('phrase:are you sure?'),
    //   actions: [Dialog.CancelAction(), Dialog.OKAction(() => deleteEvent(id))],
    //   bgSize: 'small',
    // });
  };

  const effectRestoreEvent = (id) => {
    showDialog(id, t('title:event delete'), restoreEvent)
    // Dialog.setOptions({
    //   defaultOkLabel: t('label:yes'),
    //   defaultCancelLabel: t('label:no'),
    //   primaryClassName: 'btn-success',
    //   defaultButtonClassName: 'btn-danger',
    // });

    // dialog.show({
    //   title: t('title:event restore'),
    //   body: t('phrase:are you sure?'),
    //   actions: [Dialog.CancelAction(), Dialog.OKAction(() => restoreEvent(id))],
    //   bgSize: 'small',
    // });
  };

  const updateStatus = id => {
    const formData = new FormData()
    formData.append('id', id)
    finishEvent(formData)
  }

  const showDialog = (id, title, cb) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      title,
      body: 'Tem certeza ?',
      actions: [Dialog.CancelAction(), Dialog.OKAction(() => cb(id))],
      bgSize: 'medium'
    });
  }

  return (
    <>
      <Dialog
        ref={(component) => {
          dialog = component;
        }}
      />
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:events list')}</h4>
          </Col>
        </Row>
        <Row>
          <Col>
          {!trash && !finished ?(
            <Form.Group>
              <Form.Label style={{ display: 'block' }}>&nbsp;</Form.Label>
              <Can do="createEvent" on="App">
                <Button size="sm" className="login-btn mr-1" variant="primary-login" as={Link} to="/events/create">
                  <i className="fas fa-plus" />
                  &nbsp;
                  {t('label:add new')}
                </Button>
              </Can>
              &nbsp;
              {/* <Can do="listUsers" on="App"> */}
                <Button
                  size="sm"
                  variant="secondary"
                  as={Link}
                  to="/events/trash"
                >
                  <i className="fas fa-trash"></i> {t('label:view trash')}
                </Button>
                <Button
                  size="sm"
                  variant="secondary"
                  className='ml-2'
                  as={Link}
                  to="/events/finished"
                >
                  <i className="fas fa-calendar-check"></i> Visualizar Finalizados
                </Button>
              {/* </Can> */}
            </Form.Group>
          ):(
            <Form.Group>
              <Form.Label style={{ display: 'block' }}>&nbsp;</Form.Label>
              <Button size="sm" className="login-btn mr-1" variant="primary-login" as={Link} to="/events">
                <i className="fas fa-arrow-left"></i> {t('label:go back')}
              </Button>
            </Form.Group>
          )}
          </Col>
        </Row>
        <Row>
          <Col>
            <Listing
              fields={[
                { name: 'name', key: 'name', type: 'string' },
                { name: 'event type', type: 'event type' },
                { name: 'start date', key: 'start_date', type: 'date' },
                { name: 'end date', key: 'end_date', type: 'date' },
                { name: 'value', key: 'budgeted_amount', type: 'currency' },
                { name: 'total actions finished', key: 'actions_count_string', type: 'string' }
              ]}
              filters={[]}
              setFilters={setFilters}
              stateFilters={filters}
              data={data}
              handleFilterChange={handleFilterChange}
              actions={!trash?[
                (event, k) => (<>
                  <Can do="editEvent" on="App">
                    <Button
                      variant="light"
                      size="sm"
                      key={k}
                      as={Link}
                      to={finished ? `edit/${event.id}` : `events/edit/${event.id}`}
                      className="text-center align-middle"
                    >
                      <i className="fas fa-pen" />
                    </Button>
                  </Can>                  

                  {!finished ? (<>
                    <Can do="disableEvent" on="App">
                      <Button
                        size="sm"
                        key={'disabled-'+k}
                        className="ml-1"
                        variant="danger"
                        onClick={() => effectDeleteEvent(event.id)}
                        alt={t('title:delete')}
                        title={!event.can_disable ? 'Não é possível inativar eventos que possuem ações ou notas fiscais' : ''}
                        disabled={!event.can_disable}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </Can>
                    {event.actions_count[0] == event.actions_count[1] && event.can_finish ? (<>
                      <Can do="finishEvent" on="App">
                        <Button
                          variant="success"
                          size="sm"
                          key={'finish-'+k}
                          className="text-center align-middle ml-1"
                          onClick={() => showDialog(event.id, 'Concluir Evento', updateStatus)}
                        >
                          <i className="fas fa-check"></i>
                        </Button>
                      </Can>                    
                    </>) : (<></>)}
                  </>) : (<></>)}
                </>),
              ]:[
                (event, k) => (<>
                  <Can do="restoreEvent" on="App">
                    <Button
                      size="sm"
                      key={k}
                      variant="secondary"
                      onClick={() => effectRestoreEvent(event.id)}
                      alt={t('title:restore')}
                      title={t('title:restore')}
                    >
                      <i className="fas fa-trash-restore-alt"></i>
                    </Button>
                  </Can>
                </>)
              ]}
            />
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  deleteEvent: (id) => dispatch({ type: ASYNC_DELETE_EVENT, payload: { id } }),
  restoreEvent: (id) => dispatch({ type: ASYNC_RESTORE_EVENT, payload: { id } }),
  finishEvent: (payload) => dispatch({ type: ASYNC_FINISH_EVENT, payload })
});

const reduxConnect = connect(mapStateToProps, mapDispatchToProps)(EventsList);

export default MasterPage(reduxConnect);